/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import AccentButton from '../components/AccentButton';
import Accordion from '../components/Accordion';
import ButtonToggle from '../components/ButtonToggle';
import CarouselItem from '../components/CarouselItem';
import ContentBlock from '../components/ContentBlock';
import DartsCalculator from '../components/DartsCalculator';
import EntryForm from '../components/EntryForm';
import EntryForm2 from '../components/EntryForm2';
import EntryForm3 from '../components/EntryForm3';
import FeatureCarousel from '../components/FeatureCarousel';
import GamesTabs from '../components/GamesTabs';
import GraphQLConnectedDemo from '../components/GraphQL/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/GraphQL/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/GraphQL/GraphQL-Layout';
import GraphQLSSRDemo from '../components/GraphQL/GraphQL-SSRDemo';
import HeaderBanner from '../components/HeaderBanner';
import HeaderImage from '../components/HeaderImage';
import MiniPagePreview from '../components/MiniPagePreview';
import NumberNudger from '../components/NumberNudger';
import PageIntroduction from '../components/PageIntroduction';
import PagePreview from '../components/PagePreview';
import PageTabContent from '../components/PageTabContent';
import PlayerLegStats from '../components/PlayerLegStats';
import PlayerScores from '../components/PlayerScores';
import PubFinder from '../components/PubFinder';
import SegmentPopup from '../components/SegmentPopup';
import SmallPagePreview from '../components/SmallPagePreview';
import StyleguideComponentParams from '../components/Styleguide/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../components/Styleguide/Styleguide-CustomRouteType';
import StyleguideEditFrame from '../components/Styleguide/Styleguide-EditFrame';
import StyleguideFieldUsageCheckbox from '../components/Styleguide/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../components/Styleguide/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../components/Styleguide/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../components/Styleguide/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../components/Styleguide/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../components/Styleguide/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../components/Styleguide/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../components/Styleguide/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../components/Styleguide/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../components/Styleguide/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../components/Styleguide/Styleguide-FieldUsage-Text';
import StyleguideLayoutReuse from '../components/Styleguide/Styleguide-Layout-Reuse';
import StyleguideLayoutTabsTab from '../components/Styleguide/Styleguide-Layout-Tabs-Tab';
import StyleguideLayoutTabs from '../components/Styleguide/Styleguide-Layout-Tabs';
import StyleguideLayout from '../components/Styleguide/Styleguide-Layout';
import StyleguideMultilingual from '../components/Styleguide/Styleguide-Multilingual';
import StyleguideRouteFields from '../components/Styleguide/Styleguide-RouteFields';
import StyleguideSection from '../components/Styleguide/Styleguide-Section';
import StyleguideSitecoreContext from '../components/Styleguide/Styleguide-SitecoreContext';
import StyleguideSpecimen from '../components/Styleguide/Styleguide-Specimen';
import StyleguideTracking from '../components/Styleguide/Styleguide-Tracking';

const components = new Map();
components.set('AccentButton', AccentButton);
components.set('Accordion', Accordion);
components.set('ButtonToggle', ButtonToggle);
components.set('CarouselItem', CarouselItem);
components.set('ContentBlock', ContentBlock);
components.set('DartsCalculator', DartsCalculator);
components.set('EntryForm', EntryForm);
components.set('EntryForm2', EntryForm2);
components.set('EntryForm3', EntryForm3);
components.set('FeatureCarousel', FeatureCarousel);
components.set('GamesTabs', GamesTabs);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('GraphQL-SSRDemo', GraphQLSSRDemo);
components.set('HeaderBanner', HeaderBanner);
components.set('HeaderImage', HeaderImage);
components.set('MiniPagePreview', MiniPagePreview);
components.set('NumberNudger', NumberNudger);
components.set('PageIntroduction', PageIntroduction);
components.set('PagePreview', PagePreview);
components.set('PageTabContent', PageTabContent);
components.set('PlayerLegStats', PlayerLegStats);
components.set('PlayerScores', PlayerScores);
components.set('PubFinder', PubFinder);
components.set('SegmentPopup', SegmentPopup);
components.set('SmallPagePreview', SmallPagePreview);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-EditFrame', StyleguideEditFrame);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Specimen', StyleguideSpecimen);
components.set('Styleguide-Tracking', StyleguideTracking);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
